import styled from "@emotion/styled";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { grey, orange } from "@mui/material/colors";
import { Fragment, useEffect, useMemo, useState } from "react";
import { getBuyer } from "../../http/api/BuyerAPI";
import { formatNumber } from "../../utils/utils";
import { isNullEmpty } from "../../utils/validation";
import SALES_RECORD_TYPE from "../../utils/variable";
import SalesResultsItem from "./SalesResultsItem";
import {
  getMaxSalesResultsId,
  initialSalesResults,
} from "./util/InitialSalesRecord";
import { selectFirstSalesResultsAsync } from "./util/SalesRecordUtils";

const ListSalesResultsHeader = styled(Grid)({
  margin: 0,
  marginTop: 10,
  padding: 0,
  display: "flex",
  justifyContent: "center",
});

export default function SalesResults(props) {
  const {
    salesResultses,
    salesDetails,
    hasSalesDetail,
    apiSalesResults,
    renderState,
    setting,
    changeHistoryItem,
    changeHistoryItemsWithArray,
  } = props;
  const { salesRecordType } = setting.Value;
  const disableSalesResults = useMemo(() => {
    return (
      salesRecordType !== SALES_RECORD_TYPE.STOCK &&
      setting.Value.invoiceIsDisabled
    );
  }, [setting.Value]);
  const [buyers, setBuyers] = useState([]);

  const SALES_RESULTS_COLUMN_COUNT = 5;

  function updateResultsItem(index, newSalesResults) {
    salesResultses.updateIndex(index, newSalesResults);
  }
  async function GetBuyers() {
    try {
      let response = await getBuyer({});
      let listInfo = response.listBuyerInfo;
      listInfo = listInfo
        .map((o) => ({
          buyerNo: o.buyerNo,
          buyerName: o.buyerName,
        }))
        .sort((a, b) => a.buyerNo - b.buyerNo);
      setBuyers(listInfo);
      console.log("買人リスト取得");
    } catch (e) {
      console.log("買人リストを取得する際にエラー発生した：", e);
    }
  }
  useEffect(() => {
    GetBuyers();
  }, []);

  //#region Shortcut

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      //Right Enter. TODO : Use Right Enter
      if (event.location === 3) {
        event.preventDefault();
        focusNavigation(event.target, event.shiftKey);
      }
      // Left Enter + Shift
      else if (event.location === 0 && event.shiftKey) {
        event.preventDefault();
        let firstSalesDetail = document.getElementById(`salesDetail-0-0`);
        if (firstSalesDetail) firstSalesDetail.focus();
      }
    }
  }

  function handleKeyDown(event) {
    //Arrow Handle
    const keyCode = event.keyCode;
    //Arrow Key
    if (keyCode === 37) {
      event.preventDefault();
      // Handle left arrow key press
      focusNavigation(event.target, true);
    } else if (keyCode === 39) {
      event.preventDefault();
      // Handle right arrow key press
      focusNavigation(event.target, false);
    } else if (keyCode === 38) {
      const ariaExpanded =
        event.target.getAttribute("aria-expanded") === "true" ? true : false;
      if (!ariaExpanded) {
        event.preventDefault();
        const focusingItem = document.activeElement.id;
        const currentRow = parseInt(focusingItem.split("-")[1]);
        const currentColumn = parseInt(focusingItem.split("-")[2]);
        moveToElement("salesResults", currentRow - 1, currentColumn);
      }
    } else if (keyCode === 40) {
      const ariaExpanded =
        event.target.getAttribute("aria-expanded") === "true" ? true : false;
      if (!ariaExpanded) {
        event.preventDefault();
        // Handle down arrow key press
        const focusingItem = document.activeElement.id;
        const currentRow = parseInt(focusingItem.split("-")[1]);
        const currentColumn = parseInt(focusingItem.split("-")[2]);
        moveToElement("salesResults", currentRow + 1, currentColumn);
      }
    }
  }

  function focusNavigation(currentElement, isPrevious = false) {
    const focusing = currentElement.id;
    const step = isPrevious ? -1 : 1;
    const currentColumn = parseInt(focusing.split("-")[2], 10);
    const currentRow = parseInt(focusing.split("-")[1], 10);
    let nextColumn = currentColumn + step;
    let nextRow = currentRow;
    let district = "salesResults";
    // 次の列
    if (isPrevious) {
      if (nextColumn < 0) nextColumn = SALES_RESULTS_COLUMN_COUNT - 1;
      if (currentColumn === 0) {
        nextRow = currentRow - 1;
      }
    } else {
      if (nextColumn >= SALES_RESULTS_COLUMN_COUNT) {
        nextColumn = 0;
        nextRow = currentRow + 1;
      }
    }
    moveToElement(district, nextRow, nextColumn);
  }

  function moveToElement(district, row, column) {
    const maxSalesResultsId = getMaxSalesResultsId(salesResultses.Value);
    if (row + 1 > salesResultses.Value.length) {
      addNewSalesResults(maxSalesResultsId + 1);
    }
    setTimeout(() => {
      const id = `${district}-${row}-${column}`;
      const element = document.getElementById(id);
      if (element) {
        element.focus();
      } else {
      }
    }, 0);
  }

  function addNewSalesResults(salesResultsId) {
    salesResultses.push({ ...initialSalesResults, salesResultsId });
  }
  async function handleFocus(e) {
    // 販売明細が１件しかない場合は、新規に実績に移動した時に自動でNoに１設定
    if (e.target.id == "salesResults-0-0") {
      if (salesRecordType === SALES_RECORD_TYPE.STOCK) {
      }
      if (hasSalesDetail) {
        if (isNullEmpty(salesResultses.Value[0]?.salesDetailNo)) {
          salesResultses.updateIndexProp(0, "salesDetailNo", 1);
          changeHistoryItem(`result-0-salesDetailNo`, 1);
          selectFirstSalesResultsAsync();
        }
      }
    }

    e.target.select();
  }
  const totalStock = useMemo(
    () =>
      salesDetails.Value.reduce(
        (total, item) => total + (parseInt(item.quantity) || 0),
        0
      ),
    [salesDetails.Value]
  );
  const totalSalesResults = useMemo(
    () =>
      salesResultses.Value.reduce(
        (acc, cur) => acc + (parseInt(cur.quantity) || 0),
        0
      ),
    [salesResultses.Value]
  );
  const currentStock = totalStock - totalSalesResults;
  const totalAmount = useMemo(
    () =>
      salesResultses.Value.reduce(
        (acc, cur) => acc + parseInt(cur.quantity * cur.unitPrice),
        0
      ),
    [salesResultses.Value]
  );

  //#endregion
  return (
    <Fragment>
      {/* 合計 */}
      <Grid container>
        <Grid item xs={6}></Grid>
        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <Box display="flex" justifyContent="flex-end">
            <Typography fontSize={25} marginRight={10}>
              在庫合計： {formatNumber(totalStock)}
            </Typography>
            <Typography fontSize={25} marginRight={10}>
              実績合計 : {formatNumber(totalSalesResults)}（残：
              {formatNumber(currentStock)}）
            </Typography>

            <Typography fontSize={25}>
              合計金額 : {formatNumber(totalAmount)}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* 3 */}
      <ListSalesResultsHeader
        container
        sx={{ backgroundColor: orange[100], borderRadius: 2 }}
      >
        <Grid item xs={0.7}>
          <Typography variant="h5" textAlign={"center"}>
            No.
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            単価
          </Typography>
        </Grid>
        <Grid item xs={3.5}>
          <Typography variant="h5" textAlign={"center"}>
            買人
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            数量
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            コンテナ数
          </Typography>
        </Grid>
        <Grid item xs={1.8}>
          <Typography variant="h5" textAlign={"center"}>
            備考
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            金額
          </Typography>
        </Grid>
      </ListSalesResultsHeader>
      <Box
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
      >
        {salesResultses.Value.map((salesResults, index) => {
          return (
            <Fragment key={`sales-results-${index}`}>
              {index % 5 == 0 && index != 0 && (
                <Divider
                  sx={{
                    borderBottomWidth: 5,
                    borderBottomColor: grey[500],
                    marginBlock: 2,
                  }}
                ></Divider>
              )}
              <SalesResultsItem
                salesResults={salesResults}
                apiSalesResults={apiSalesResults}
                index={index}
                update={updateResultsItem}
                updateIndexProp={salesResultses.updateIndexProp}
                buyers={buyers}
                focusNavigation={focusNavigation}
                renderState={renderState}
                disableSalesResults={disableSalesResults}
                changeHistoryItem={changeHistoryItem}
                changeHistoryItemsWithArray={changeHistoryItemsWithArray}
              />
            </Fragment>
          );
        })}
      </Box>

      {/* 合計 */}
      <Grid container marginTop={3}>
        <Grid xs={6}></Grid>
        <Grid xs={6} display="flex" justifyContent="flex-end">
          <Box display="flex" justifyContent="flex-end">
            <Typography fontSize={25} marginRight={10}>
              在庫合計：
              {salesDetails.Value.reduce(
                (total, item) => total + (parseInt(item.quantity) || 0),
                0
              )}
            </Typography>
            <Typography fontSize={25} marginRight={10}>
              実績合計 :{" "}
              {salesResultses.Value.reduce(
                (acc, cur) => acc + (parseInt(cur.quantity) || 0),
                0
              )}
            </Typography>

            <Typography fontSize={25}>
              合計金額 :{" "}
              {salesResultses.Value.reduce(
                (acc, cur) => acc + parseInt(cur.quantity * cur.unitPrice),
                0
              )}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}
